import { useCallback, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { KyrgyzstanSortWidget } from 'widgets/kyrgyzstan/sort'

import type { SortOption } from 'entities/kyrgyzstan/model'
import { kyrgyzstanSearchStore } from 'entities/kyrgyzstan/model'
import { defaultSortOptionValue } from 'entities/kyrgyzstan/model/search/sort'

import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import s from './styles.module.scss'

const KyrgyzstanSortPage = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { sort, setSort } = kyrgyzstanSearchStore

  const [currentSort, setCurrentSort] = useState<string>(
    sort || defaultSortOptionValue,
  )

  const isCanApply = currentSort !== sort
  const isCanReset = currentSort !== defaultSortOptionValue

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleReset = () => {
    setCurrentSort(defaultSortOptionValue)
    setSort(defaultSortOptionValue)
  }

  const handleSelect = useCallback((option: SortOption) => {
    setCurrentSort(option.value)
  }, [])

  const handleApply = () => {
    setSort(currentSort)
    navigate(-1)
  }

  return (
    <div className={s.container}>
      <HeaderResetButton
        title={t('kyrgyzstan_block.sort.title')}
        onBack={handleGoBack}
        onReset={handleReset}
        isIconBlack
        isCanDisable={isCanReset}
      />

      <KyrgyzstanSortWidget
        className="container"
        selectedId={currentSort}
        onChange={handleSelect}
      />

      <ButtonContinue
        onClick={handleApply}
        disabled={!isCanApply}
      >
        <span className="semi-bold-17">{t('apply')}</span>
      </ButtonContinue>
    </div>
  )
})

export default KyrgyzstanSortPage
